// enum -
export enum MORPH_PAGE_STATE {
  IDLE = 0,
  MORPH_CONFIRM,
  MORPHING,
  MORPH_SUCCESS,
  REFETCH_DETAIL
}
